import { Navigate } from "react-router-dom";
import { Role, useAuthStore } from "../../stores/auth";
import { shallow } from "zustand/shallow";

function HomeRedirect() {
  const [hasRole] = useAuthStore((state) => [state.hasRole], shallow);

  if (hasRole(Role.TECHNICIAN) || hasRole(Role.OFFICE)) {
    return <Navigate to="home" replace />;
  }

  return <Navigate to="delivery_notes" replace />;
}

export default HomeRedirect;
